import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './post-a-listing.css'

const PostAListing = (props) => {
  return (
    <div className="post-a-listing-container10">
      <Helmet>
        <title>Post-a-Listing - Dogeet</title>
        <meta
          property="og:title"
          content="Post-a-Listing - Dogeet"
        />
        <link
          rel="canonical"
          href="https://dogeet.com/post-a-listing"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="post-a-listing-container11">
        <div className="post-a-listing-container12">
          <Script
            html={`<style>
input:checked + .listing-slider {
  background-color: var(--color-primary);
}
input:checked + .listing-slider:before {
  transform: translateX(26px);
}
</style>`}
          ></Script>
        </div>
      </div>
      <section className="post-a-listing-listing-hero">
        <div className="listing-hero-media">
          <video
            autoPlay="true"
            muted="true"
            loop="true"
            playsInline="true"
            poster="https://images.pexels.com/videos/16504264/pictures/preview-0.jpeg"
            src="https://videos.pexels.com/video-files/16504264/16504264-hd_1280_720_25fps.mp4"
          ></video>
          <div className="listing-hero-overlay"></div>
        </div>
        <div className="listing-hero-container">
          <div className="listing-hero-content">
            <div className="listing-hero-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 12h6M9 6v12m-3 0h6a6 6 0 1 0 0-12H6"
                ></path>
              </svg>
              <span>Community Bazaar</span>
            </div>
            <h1 className="hero-title">Got wares? Post &apos;em for DOGE!</h1>
            <p className="hero-subtitle">
              Turn your stuff into digital gold. Join the friendliest
              peer-to-peer marketplace on the moon.
            </p>
            <div className="listing-hero-progress">
              <div className="listing-hero-progress-bar">
                <div className="listing-hero-progress-fill"></div>
              </div>
              <span className="section-content">
                Ready to start: 0% complete
              </span>
            </div>
            <a href="#post-form">
              <div className="listing-hero-cta btn btn-primary btn-xl">
                <span>Start Listing</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2"></path>
                    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m1 7v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                  </g>
                </svg>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section id="post-form" className="listing-steps">
        <div className="listing-steps-container">
          <h2 className="section-title">Let&apos;s build your listing</h2>
          <form
            action="/post"
            method="POST"
            data-form-id="f1b68ace-8b57-41c4-b733-79c3199299e3"
            className="listing-steps-form"
          >
            <ol className="listing-steps-list">
              <li className="listing-step-item active">
                <div className="listing-step-number">
                  <span>1</span>
                </div>
                <div className="listing-step-body">
                  <h3 className="section-subtitle">What are you selling?</h3>
                  <div className="listing-input-group">
                    <label htmlFor="listing-title">Listing Title</label>
                    <input
                      type="text"
                      id="listing-title"
                      placeholder="e.g. Vintage Shiba Statue"
                      required="true"
                      minlength="5"
                      name="textinput"
                      data-form-field-id="listing-title"
                    />
                    <span className="listing-tip">
                      Tip: Catchy titles get 3x more boops!
                    </span>
                  </div>
                </div>
              </li>
              <li className="listing-step-item">
                <div className="listing-step-number">
                  <span>2</span>
                </div>
                <div className="listing-step-body">
                  <h3 className="section-subtitle">Show it off</h3>
                  <div className="listing-photo-upload">
                    <div className="listing-photo-placeholder">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        >
                          <path d="M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z"></path>
                          <circle cx="12" cy="13" r="3"></circle>
                        </g>
                      </svg>
                      <p>Drag photos here or click to upload</p>
                    </div>
                    <input
                      type="file"
                      multiple="true"
                      accept="image/*"
                      id="thq_textinput_orQd"
                      name="textinput"
                      data-form-field-id="thq_textinput_orQd"
                      className="listing-file-input"
                    />
                  </div>
                </div>
              </li>
              <li className="listing-step-item">
                <div className="listing-step-number">
                  <span>3</span>
                </div>
                <div className="listing-step-body">
                  <h3 className="section-subtitle">Set your price</h3>
                  <div className="listing-price-row">
                    <div className="listing-input-group flex-1">
                      <label htmlFor="listing-price-doge">Price in DOGE</label>
                      <div className="listing-input-prefix">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 12h6M9 6v12m-3 0h6a6 6 0 1 0 0-12H6"
                          ></path>
                        </svg>
                        <input
                          type="number"
                          id="listing-price-doge"
                          placeholder="420.69"
                          required="true"
                          name="textinput"
                          data-form-field-id="listing-price-doge"
                        />
                      </div>
                    </div>
                    <div className="listing-input-group flex-1">
                      <label htmlFor="listing-price-usd">
                        USD Reference (Optional)
                      </label>
                      <div className="listing-input-prefix">
                        <span className="section-content">$</span>
                        <input
                          type="text"
                          id="listing-price-usd"
                          placeholder="Auto-calculating..."
                          name="textinput"
                          data-form-field-id="listing-price-usd"
                          readOnly="true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="listing-step-item">
                <div className="listing-step-number">
                  <span>4</span>
                </div>
                <div className="listing-step-body">
                  <h3 className="section-subtitle">Contact Method</h3>
                  <div className="listing-input-group">
                    <select
                      id="contact-method"
                      required="true"
                      name="select"
                      data-form-field-id="contact-method"
                    >
                      <option value="true">Select how buyers reach you</option>
                      <option value="masked">
                        Masked Email Relay (Safer!)
                      </option>
                      <option value="direct">Direct Message</option>
                      <option value="external">External Link</option>
                    </select>
                  </div>
                </div>
              </li>
            </ol>
          </form>
        </div>
      </section>
      <section className="listing-pricing">
        <div className="listing-pricing-container">
          <div className="listing-pricing-card">
            <div className="listing-pricing-header">
              <h2 className="section-title">Value Calculator</h2>
              <p className="section-content">
                Real-time conversion for your listing
              </p>
            </div>
            <div className="listing-calc-grid">
              <div className="listing-calc-item">
                <span className="listing-calc-label">1000 DOGE</span>
                <span className="listing-calc-value">≈ $124.50 USD</span>
              </div>
              <div className="listing-calc-item">
                <span className="listing-calc-label">Network Fee</span>
                <span className="listing-calc-value">0.01 DOGE</span>
              </div>
            </div>
            <div className="listing-presets">
              <p className="section-content">Quick Presets:</p>
              <div className="listing-preset-chips">
                <button type="button" className="listing-chip">
                  100 DOGE
                </button>
                <button type="button" className="listing-chip">
                  500 DOGE
                </button>
                <button type="button" className="listing-chip">
                  1000 DOGE
                </button>
                <button type="button" className="listing-chip">
                  5000 DOGE
                </button>
              </div>
            </div>
            <div className="listing-featured-toggle">
              <div className="listing-toggle-info">
                <h4 className="section-subtitle">Rocket Boost (Featured)</h4>
                <p className="section-content">
                  Pin your listing to the top of the map!
                </p>
              </div>
              <div className="listing-toggle-action">
                <span className="listing-cost">+50 DOGE</span>
                <label className="listing-switch">
                  <input type="checkbox" />
                  <span className="post-a-listing-thq-listing-slider-elm"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="listing-explore">
        <div className="listing-explore-container">
          <div className="listing-explore-header">
            <h2 className="section-title">Pick a Category</h2>
            <p className="section-content">
              Help Shibes find your wares faster
            </p>
          </div>
          <div className="listing-category-grid">
            <button className="listing-cat-item">
              <div className="post-a-listing-thq-listing-cat-icon-elm1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
                    <circle
                      cx="7.5"
                      cy="7.5"
                      r=".5"
                      fill="currentColor"
                    ></circle>
                  </g>
                </svg>
              </div>
              <span className="section-subtitle">Electronics</span>
              <span className="section-content">Gadgets &amp; Tech</span>
            </button>
            <button className="listing-cat-item">
              <div className="post-a-listing-thq-listing-cat-icon-elm2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                  ></path>
                </svg>
              </div>
              <span className="section-subtitle">Real Estate</span>
              <span className="section-content">Housies &amp; Lands</span>
            </button>
            <button className="listing-cat-item">
              <div className="post-a-listing-thq-listing-cat-icon-elm3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2"></path>
                    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m1 7v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                  </g>
                </svg>
              </div>
              <span className="section-subtitle">Collectibles</span>
              <span className="section-content">Memes &amp; Art</span>
            </button>
            <button className="listing-cat-item">
              <div className="post-a-listing-thq-listing-cat-icon-elm4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  ></path>
                </svg>
              </div>
              <span className="section-subtitle">Services</span>
              <span className="section-content">Skills for Hire</span>
            </button>
            <button className="listing-cat-item">
              <div className="post-a-listing-thq-listing-cat-icon-elm5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
              </div>
              <span className="section-subtitle">Vehicles</span>
              <span className="section-content">Cars &amp; Lambos</span>
            </button>
            <button className="listing-cat-item">
              <div className="post-a-listing-thq-listing-cat-icon-elm6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8"
                  ></path>
                  <path d="m22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7m14 12l2 2l4-4"></path>
                </svg>
              </div>
              <span className="section-subtitle">Other</span>
              <span className="section-content">Misc Goodies</span>
            </button>
          </div>
          <div className="listing-suggestion">
            <p className="section-content">
              <span>
                Suggested tags:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>#vintage</span>
              <span>#tech</span>
              <span>#rare</span>
              <span>#local-only</span>
            </p>
          </div>
        </div>
      </section>
      <section className="listing-search">
        <div className="listing-search-container">
          <div className="listing-split-content">
            <div className="listing-map-info">
              <h2 className="section-title">Where is it?</h2>
              <p className="section-content">
                Set your discovery radius. We don&apos;t share your exact
                address, just a friendly neighborhood circle.
              </p>
              <div className="listing-location-controls">
                <button className="btn btn-outline btn-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </g>
                  </svg>
                  <span>Detect My Spot</span>
                </button>
                <div className="listing-radius-slider">
                  <label className="section-content">
                    <span>
                      Search Radius:
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span id="radius-val">5 km</span>
                  </label>
                  <input
                    type="range"
                    min="1"
                    max="50"
                    value="5"
                    className="listing-range"
                  />
                </div>
              </div>
            </div>
            <div className="listing-map-visual">
              <div className="listing-map-mockup">
                <img
                  src="https://images.pexels.com/photos/9956262/pexels-photo-9956262.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Local Discovery Map"
                  className="listing-map-img"
                />
                <div className="listing-map-pin">
                  <div className="listing-pin-ripple"></div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="var(--color-primary)"
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                    ></path>
                  </svg>
                </div>
                <div className="listing-preview-card">
                  <img
                    src="https://images.pexels.com/photos/4588051/pexels-photo-4588051.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Listing Preview"
                  />
                  <div className="listing-preview-info">
                    <span className="section-subtitle">Shiba Hat</span>
                    <span className="listing-preview-price">420 DOGE</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="listing-about">
        <div className="listing-about-container">
          <h2 className="section-title">Community Rules</h2>
          <p className="section-content">
            Keep Dogeet friendly and safe for everyone.
          </p>
          <div className="listing-accordion">
            <details open="true">
              <summary>
                <span className="section-subtitle">What can I sell?</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m6 9l6 6l6-6"
                  ></path>
                </svg>
              </summary>
              <div className="listing-accordion-content">
                <p className="section-content">
                  Almost anything! From vintage toys to web design services. As
                  long as it&apos;s legal and follows our &quot;No Mean
                  Shibes&quot; policy, you&apos;re good to go.
                </p>
                <ul className="listing-rules-list">
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span> Physical Goods</span>
                  </li>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span> Digital Art &amp; Services</span>
                  </li>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span> Local Meetup Swaps</span>
                  </li>
                </ul>
              </div>
            </details>
            <details>
              <summary>
                <span className="section-subtitle">Prohibited Items</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m6 9l6 6l6-6"
                  ></path>
                </svg>
              </summary>
              <div className="listing-accordion-content">
                <p className="section-content">
                  We have a zero-tolerance policy for illegal items, weapons, or
                  anything that promotes hate. Check our full list of prohibited
                  items in the community guidelines.
                </p>
              </div>
            </details>
            <details>
              <summary>
                <span className="section-subtitle">
                  Safety &amp; Non-Custodial Trading
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m6 9l6 6l6-6"
                  ></path>
                </svg>
              </summary>
              <div className="listing-accordion-content">
                <p className="section-content">
                  Dogeet is non-custodial. We never hold your DOGE. Transactions
                  happen directly between you and the buyer. Always meet in
                  public places for local trades!
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section className="listing-final-preview">
        <div className="listing-final-container">
          <div className="listing-final-top">
            <div className="listing-final-card">
              <div className="listing-final-image-wrap">
                <img
                  src="https://images.pexels.com/photos/4588051/pexels-photo-4588051.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Your Listing Preview"
                />
                <div className="listing-final-badge">
                  <span>PREVIEW</span>
                </div>
              </div>
              <div className="listing-final-details">
                <div className="listing-final-meta">
                  <h2 className="section-title">Vintage Shiba Statue</h2>
                  <p className="section-subtitle">Electronics • 5km away</p>
                </div>
                <div className="listing-final-price-box">
                  <span className="listing-final-doge">1000 DOGE</span>
                  <span className="listing-final-usd">≈ $124.50 USD</span>
                </div>
                <p className="section-content">
                  Very rare. Much wow. Only selling because I need more DOGE for
                  the moon mission.
                </p>
                <div className="listing-final-actions">
                  <button className="btn btn-outline btn-sm">
                    Edit Details
                  </button>
                  <button className="btn btn-outline btn-sm">
                    Change Photos
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="listing-final-summary">
            <div className="listing-summary-item">
              <span className="section-content">Listing Visibility</span>
              <span className="listing-status-badge">High (Featured)</span>
            </div>
            <div className="listing-summary-item">
              <span className="section-content">Total to Pay</span>
              <span className="listing-total-price">50.01 DOGE</span>
            </div>
            <button className="listing-submit-btn btn btn-primary btn-xl">
              <span>Post for 50.01 DOGE</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M20 6L9 17l-5-5"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </section>
      <section id="success-screen" className="listing-confirmation">
        <div className="listing-conf-container">
          <div className="listing-conf-top">
            <div className="listing-conf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2"></path>
                  <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m1 7v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                </g>
              </svg>
            </div>
            <h2 className="hero-title">To the Moon!</h2>
            <p className="hero-subtitle">
              Your listing is now live in the community bazaar.
            </p>
            <div className="listing-permalink">
              <span className="section-content">
                dogeet.com/listing/vntg-shiba-420
              </span>
              <button className="btn btn-sm btn-link">Copy Link</button>
            </div>
          </div>
          <div className="listing-conf-grid">
            <div className="listing-conf-card">
              <h4 className="section-subtitle">Boost Visibility</h4>
              <p className="section-content">
                Share your listing on X (Twitter) or Reddit to reach more Shibes
                instantly.
              </p>
              <div className="listing-share-btns">
                <button className="btn btn-outline btn-sm">Share on X</button>
                <button className="btn btn-outline btn-sm">Reddit</button>
              </div>
            </div>
            <div className="listing-conf-card">
              <h4 className="section-subtitle">What&apos;s Next?</h4>
              <p className="section-content">
                Check your messages often. Buyers might reach out with questions
                or offers.
              </p>
              <div className="listing-next-actions">
                <button className="btn btn-lg btn-secondary">
                  Post Another Item
                </button>
                <button className="btn btn-primary btn-lg">Browse Map</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="post-a-listing-container19">
        <div className="post-a-listing-container20">
          <Script
            html={`<style>
        @keyframes ripple {0% {transform: translate(-50%, -50%) scale(0.5);
opacity: 1;}
100% {transform: translate(-50%, -50%) scale(2);
opacity: 0;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="post-a-listing-container21">
        <div className="post-a-listing-container22">
          <Script
            html={`<script defer data-name="listing-flow">
(function(){
  const radiusInput = document.querySelector('.listing-range');
  const radiusVal = document.getElementById('radius-val');
  
  if (radiusInput && radiusVal) {
    radiusInput.addEventListener('input', (e) => {
      radiusVal.textContent = \`\${e.target.value} km\`;
    });
  }

  const dogeInput = document.getElementById('listing-price-doge');
  const usdInput = document.getElementById('listing-price-usd');
  
  if (dogeInput && usdInput) {
    dogeInput.addEventListener('input', (e) => {
      const val = parseFloat(e.target.value);
      if (!isNaN(val)) {
        usdInput.value = (val * 0.1245).toFixed(2);
      } else {
        usdInput.value = '';
      }
    });
  }

  const stepItems = document.querySelectorAll('.listing-step-item');
  const inputs = document.querySelectorAll('.listing-steps-form input, .listing-steps-form select');
  const progressFill = document.querySelector('.listing-hero-progress-fill');

  inputs.forEach(input => {
    input.addEventListener('change', () => {
      let filled = 0;
      inputs.forEach(i => { if(i.value) filled++; });
      const percent = Math.min(100, Math.round((filled / inputs.length) * 100));
      if (progressFill) progressFill.style.width = \`\${percent}%\`;
      
      stepItems.forEach((item, index) => {
        if (index <= filled) item.classList.add('active');
      });
    });
  });

  const submitBtn = document.querySelector('.listing-submit-btn');
  const successScreen = document.getElementById('success-screen');
  
  if (submitBtn && successScreen) {
    submitBtn.addEventListener('click', () => {
      submitBtn.innerHTML = 'Sending to Moon...';
      setTimeout(() => {
        window.scrollTo({ top: successScreen.offsetTop, behavior: 'smooth' });
      }, 1500);
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default PostAListing
